<template>
  <div :class="getClassName('parts')">
    <div :class="getClassName('categories')">
      <button
        :class="getClassName('categories__button')"
        type="button"
        v-for="category in item.parts_categories"
        :key="category.id"
        @click="showModal(category)"
      >
        <v-img
          :class="getClassName('categories__icon')"
          :src="category.icon"
          :width="media ? '31px' : '34px'"
          :height="media ? '31px' : '34px'"
          v-if="category.icon !== null"
        />
        <div :class="getClassName('categories__name')">{{ category.name }}</div>
      </button>
      <button v-if="this.noPartsVueFlg"
        :class="getNoPartsActive('categories__button')"
        type="button"
        @click="showModalForNoParts()"
      >
        <v-img
          :class="getClassName('categories__icon')"
          :src="'../../images/icon_noselection.jpg'"
          :width="media ? '31px' : '34px'"
          :height="media ? '31px' : '34px'"
        />
        <div :class="getClassName('categories__name')">パーツなし</div>
      </button>
    </div>

    <slot name="items" />

    <div :class="getClassName('modal')" v-if="visible">
      <div :class="getClassName('modal__overlay')" @click="hideModal"></div>
      <div :class="getClassName('modal__wrapper')">
        <button class="modal__close--upper" type="button" @click="hideModal">
          <span class="modal__cross--white" />
        </button>
        <div :class="getClassName('modal__content')">
          <div :class="getClassName('modal__scroll')">
            <div :class="getClassName('modal__title')">{{ category.name }}</div>
            <p :class="getClassName('modal__comment')" v-if="showComment(category)">
              {{ item.category.name.replace(' ', '') }}1{{ item.unit }}につきパーツが8本必要になります
            </p>
            <div :class="getClassName('modal__options')">
              <template v-for="item in category.items">
                <label
                  :class="getClassNameActive('modal__option', setValue(item, option), parts)"
                  v-for="option in item.options"
                  :key="`${uuid}-${option.id}`"
                  :for="`${uuid}-${option.id}`"
                >
                  <v-img :src="option.color.thumbnail" :alt="option.color.name" contain :aspect-ratio="1" />
                  <div :class="getClassName('modal__name')">{{ item.name }} {{ option.color.name }}</div>
                  <div :class="getClassName('modal__size')" v-if="item.sizes.length > 1">
                    {{ option.size.name }}
                  </div>
                  <div :class="getClassName('modal__price')">
                    {{ getPriceFormat(option.price) }}円（税込）
                  </div>
                  <input
                    :id="`${uuid}-${option.id}`"
                    type="checkbox"
                    :value="setValue(item, option)"
                    v-model="parts"
                    v-show="false"
                  />
                </label>
              </template>
            </div>
          </div>
          <button :class="getClassName('modal__add')" type="button" @click="add">
            チェックした商品を追加する
          </button>
          <button class="modal__close" type="button" @click="hideModal" v-if="!media">
            <span class="modal__cross" />
            閉じる
          </button>
        </div>
      </div>
    </div>

    <div :class="getClassName('modal')" v-if="visibleForNoParts">
      <div :class="getClassName('modal__overlay')" @click="hideModalForNoParts"></div>
      <div :class="getClassName('modal__wrapper')">
        <button class="modal__close--upper" type="button" @click="hideModalForNoParts">
          <span class="modal__cross--white" />
        </button>
        <div :class="getClassName('modal__content')">
          <div :class="getClassName('modal__scroll')">
            <div :class="getClassName('modal__title')">パーツなし</div>
            <p :class="getClassName('modal__comment--noparts')">
              こちらの商品には取り付けパーツは付属しておりません。<br>パーツがないと吊ることができません。<br>※オプションパーツをご希望の方は別途購入が必要です。
            </p>
          </div>
          <button :class="getClassName('modal__add')" type="button" @click="selectNoParts">
            了承して選択する
          </button>
          <button class="modal__close" type="button" @click="hideModalForNoParts" v-if="!media">
            <span class="modal__cross" />
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import { numberFormat } from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
    noPartsVueFlg: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    const uuid = uuidv4();
    return {
      uuid: uuid,
      parts: [],
      visible: false,
      visibleForNoParts: false,
      category: null,
      noPartsFlg: false,
    };
  },
  computed: {
    getClassNameActive() {
      return (className, data, value) => {
        const isActive = value.some(
          (v) =>
            data.item_id === v.item_id &&
            data.item_color_id === v.item_color_id &&
            data.item_size_id === v.item_size_id &&
            data.item_option_id === v.item_option_id
        );
        return [this.getClassName(className), isActive ? className + '--active' : null];
      };
    },
    getPriceFormat() {
      return (number) => numberFormat(number);
    },
    setValue() {
      return (item, option) => ({
        item_id: item.id,
        item_color_id: option.color.id,
        item_size_id: option.size.id,
        item_option_id: option.id,
        quantity: 1,
      });
    },
    showComment() {
      if (this.item.category.slug !== 'curtain-madomo' && this.item.category.slug !== 'mekakushi-madomo')
        return (category) => false;

      return (category) => category.slug === 'button-strap' || category.slug === 'ribbon';
    },
  },
  methods: {
    showModal(category) {
      this.category = category;
      this.visible = true;
    },
    hideModal() {
      this.category = null;
      this.visible = false;
      this.parts = [];
    },
    showModalForNoParts() {
      // 「パーツなし」を選択した場合のポップアップ
      if (this.item.id === 220
      || this.item.id === 221
      || this.item.id === 222
      || this.item.id === 223
      || this.item.id === 255
      || this.item.id === 257
      || this.item.id === 216
      || this.item.id === 217
      || this.item.id === 218
      || this.item.id === 219
      || this.item.id === 256
      || this.item.id === 258) {
        // 商品固有の設定：ooasa・kami 商品の場合は、ポップアップを表示しない
        this.selectNoParts();
      } else {
        this.visibleForNoParts = true;
      }
    },
    hideModalForNoParts() {
      // 「パーツなし」を選択した場合のポップアップを閉じる
      this.visibleForNoParts = false;
    },
    add() {
      if(this.noPartsFlg){
        this.noPartsFlg = false;
        this.$emit('noSelection', this.noPartsFlg);
      }

      if (this.value.parts.length === 0) {
        this.$emit('input', { ...this.value, parts: this.parts });
        this.hideModal();
        return;
      }

      const parts = [...this.value.parts];
      this.parts.forEach((part) => {
        let duplicate = false;
        parts.forEach((selected, index) => {
          if (
            selected.item_id !== part.item_id ||
            selected.item_color_id !== part.item_color_id ||
            selected.item_size_id !== part.item_size_id ||
            selected.item_option_id !== part.item_option_id
          )
            return;

          duplicate = true;
          parts[index] = { ...selected, quantity: selected.quantity + part.quantity };
        });

        if (!duplicate) parts.push(part);
      });

      this.$emit('input', { ...this.value, parts: parts });
      this.hideModal();
    },
    selectNoParts() {
      this.noPartsFlg = true;
      this.$emit('noSelection', this.noPartsFlg);
      this.$emit('input', { ...this.value, parts: [] });
      this.hideModalForNoParts();
    },
    getNoPartsActive(className){
      return [this.getClassName(className), this.noPartsFlg ? className + '--active' : null];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';
@import '../../_sass/mixins';

.parts {
  .parts-items {
    margin-top: 44px;
    &--sp {
      padding-top: 19px;
      border-top: solid 1px $color__line--item;
      margin-top: 20px;
    }
  }
}

.categories {
  width: calc(100% + 10px);
  margin: -5px;
  display: flex;
  flex-flow: row wrap;
  &--sp {
    width: 100%;
    margin: 0;
  }
  &__button {
    background: #fff;
    min-width: 130px;
    height: 44px;
    padding: 3px;
    border: solid 2px currentcolor;
    border-radius: 22px;
    box-sizing: border-box;
    margin: 5px;
    display: flex;
    align-items: center;
    &--sp {
      width: 100%;
      height: 40px;
      padding: 2.5px;
      border-radius: 20px;
    }

    &--active {
      box-shadow: 0px 0px 0px 4px $color__active;
      border: 0;
    }
  }
  &__icon {
    border-radius: 50%;
    flex: 0 0 auto;
  }
  &__name {
    padding: 0 18px 0 3px;
    font-size: 1.3rem;
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    &--sp {
      padding: 0 34px 0 3px;
      font-size: 1rem;
      line-height: 1.2;
    }
  }
}

@import '../../_sass/modal';

.modal {
  &__overlay {
    @extend %overlay;
  }
  &__wrapper {
    @extend %wrapper;
    width: 560px;
    &--sp {
      width: 87.5%;
    }
  }
  &__content {
    background: #f9f9f9;
    padding: 44px 0;
    border: solid 1px #a1a1a1;
    box-sizing: border-box;
    box-shadow: 4px 4px 1px 0px rgba(35, 24, 21, 0.2);
    &--sp {
      padding: 9px 0 29px;
    }
  }
  &__scroll {
    height: 100%;
    max-height: calc(80vh - 210px);
    padding: 0 29px;
    box-sizing: border-box;
    overflow: auto;
    &--sp {
      max-height: calc(80vh - 90px);
      padding: 0 16px;
    }
  }
  &__title {
    @include title;
    font-size: 2rem;
    text-align: center;
    &--sp {
      font-size: 1.4rem;
    }
  }
  &__comment {
    font-size: 1.8rem;
    text-align: center;
    &--sp {
      font-size: 1.1rem;
      &::before {
        content: none;
      }
    }
    &--noparts {
      font-size: 1.5rem;
      color: $color__active;
      text-align: center;
      margin-top: 20px;
      &--sp {
        font-size: 1.1rem;
        margin-top: 10px;
      }
    }
  }
  &__options {
    margin-top: 10px;
    margin-right: -1px;
    display: flex;
    flex-flow: row wrap;
  }
  &__option {
    width: calc((100% - 4px) / 3 - 8px);
    background: #fff;
    padding: 4px;
    border-bottom: solid 1px $color__line--item;
    border-right: solid 1px $color__line--item;
    box-sizing: content-box;
    position: relative;
    display: block;
    flex: 0 0 auto;
    cursor: pointer;
    &:nth-child(-n + 3) {
      border-top: solid 1px $color__line--item;
    }
    &:nth-child(3n + 1) {
      border-left: solid 1px $color__line--item;
    }
    &::before {
      content: '';
      background: url(../images/check.svg) no-repeat center center;
      background-color: #fff;
      background-size: 19px 14px;
      width: 35px;
      height: 35px;
      border: solid 1px #d0d0d0;
      box-sizing: border-box;
      border-radius: 50%;
      transition: all 0.2s ease 0s;
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 1;
    }
    &--active::before {
      background-color: $color__active;
      border-color: $color__active;
    }
    &--sp::before {
      background-size: 9px auto;
      width: 17px;
      height: 17px;
      top: 6px;
      left: 6px;
    }
  }
  &__name {
    margin-top: 20px;
    &--sp {
      margin-top: 10px;
    }
  }
  &__add {
    background: $color__active;
    width: 455px;
    height: 54px;
    border-radius: 27px;
    margin: 20px auto 0;
    color: #fff;
    font-size: 1.5rem;
    letter-spacing: 0.03em;
    line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &--sp {
      width: calc(100% - 32px);
      height: 30px;
      border-radius: 15px;
      margin-top: 20px;
      font-size: 1.1rem;
    }
  }

  &__close {
    width: 66px;
    margin: 20px auto 0;
    outline: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--upper {
      width: 15px;
      height: 15px;
      justify-content: center;
      position: absolute;
      top: -30px;
      right: 0;
    }
  }
  &__cross {
    @extend %cross;
    &--white {
      @extend %cross;
      width: 100%;
      height: 100%;
      display: block;
      &::before,
      &::after {
        border-color: #fff;
      }
    }
  }
}
</style>
